import { extendTheme, type ThemeConfig } from '@chakra-ui/react';

// Design system do app.piloto.life — suporte a modo claro/escuro persistido (toggle na sidebar).
const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false, // controlado pelo toggle; a escolha é persistida pelo Chakra
};

const theme = extendTheme({
  config,
  styles: {
    global: (props: { colorMode: 'light' | 'dark' }) => ({
      body: {
        bg: props.colorMode === 'dark' ? 'gray.900' : 'gray.50',
        color: props.colorMode === 'dark' ? 'gray.100' : 'gray.800',
      },
    }),
  },
  // Tokens semânticos p/ superfícies — quem usar troca de cor automaticamente por modo.
  semanticTokens: {
    colors: {
      surface: { default: 'white', _dark: 'gray.800' },
      'surface.muted': { default: 'gray.50', _dark: 'gray.900' },
      'surface.raised': { default: 'white', _dark: 'gray.700' },
      'surface.subtle': { default: 'gray.100', _dark: 'gray.700' },
      'border.subtle': { default: 'gray.200', _dark: 'gray.700' },
      'text.muted': { default: 'gray.600', _dark: 'gray.400' },
      // Realce de clique (linha de tabela, coluna de kanban): blackAlpha sobre gray.900
      // é imperceptível, então no escuro o único indício de que a linha é clicável sumia.
      'surface.hover': { default: 'blackAlpha.50', _dark: 'whiteAlpha.100' },
    },
  },
  components: {
    Button: {
      // Público é dono de PME usando celular: os tamanhos nativos xs (24px) e sm (32px)
      // ficam abaixo do alvo de toque de 44px e causam erro de toque em controles de uso
      // repetido (quantidade no carrinho, ações de linha). No desktop (md+) a densidade
      // original é preservada. O IconButton renderiza um Button e usa este mesmo
      // styleConfig; extendTheme faz merge profundo, então fontSize/px originais valem.
      sizes: {
        xs: { h: { base: 10, md: 6 }, minW: { base: 10, md: 6 } },
        sm: { h: { base: 10, md: 8 }, minW: { base: 10, md: 8 } },
      },
    },
    Tabs: {
      // TabList é flex sem wrap: em 360px as abas se comprimem e os rótulos quebram.
      // Rolagem horizontal (sem barra visível) é o padrão que o WhatsAppHub já usa.
      baseStyle: {
        tablist: {
          overflowX: 'auto',
          overflowY: 'hidden',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' },
        },
        tab: { whiteSpace: 'nowrap', flexShrink: 0 },
      },
    },
    Table: {
      // Maioria das tabelas do app já declara size="sm"; virar padrão evita que as
      // demais estourem a largura do celular pelo padding do tamanho padrão.
      defaultProps: { size: 'sm' },
    },
  },
});

export default theme;
